import { useMemo } from 'react';
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
    'b', 'strong', 'i', 'em', 'u', 's', 'del', 'code', 'pre', 'br', 'p', 'a',
    'blockquote', 'ul', 'ol', 'li', 'span', 'div',
];
const ALLOWED_ATTR = ['href'];
const SAFE_PROTOCOL = /^(https?|mailto|tel):/i;

// Единоразово: ссылки открываются в новой вкладке и только с безопасным протоколом
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName !== 'A') return;
    const href = node.getAttribute('href');
    if (href && !SAFE_PROTOCOL.test(href)) {
        node.removeAttribute('href');
    } else if (href) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export const hasHtml = (text) => /<\/?[a-z][^>]*>/i.test(text ?? '');

const collapseTagNewlines = (html) => html
    .replace(/\s*\n\s*(?=<(br|p|\/p|ul|ol|li|\/ul|\/ol|pre|blockquote|div)\b)/gi, '')
    .replace(/<br\s*\/?>\s*\n/gi, '<br>');

export const sanitizeHtml = (html) => DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
});

// Тело сообщения: HTML-разметка — через sanitize, иначе простой текст
export const MessageBody = ({ text, className }) => {
    const html = useMemo(
        () => (hasHtml(text) ? sanitizeHtml(collapseTagNewlines(text)) : null),
        [text],
    );
    if (html != null) {
        return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
    }
    return <div className={className}>{text}</div>;
};
